import { FC } from 'react';

import { IAppflowUpdateProgressProps } from './types';

const AppflowUpdateProgress: FC<IAppflowUpdateProgressProps> = () => null;

export default AppflowUpdateProgress;
